import Cookies from 'js-cookie';
import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { LOGIN_API_URL } from '../../../../constants/ApiUrlConstants';
import { DASHBOARD_ROUTE } from '../../../../constants/RouteNameConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import history from '../../../../features/history';
import { userLoginFailure, userLoginSuccess } from '../actions';

const loginAPI = (action) => postApiRequest(LOGIN_API_URL, action);

function forwardTo(location) {
  history.push(location);
}

function* handleLoginAPI(action) {
  try {
    const response = yield call(loginAPI, action.payload);
    const loginData = JSON.parse(response?.data?.value);
    if (response?.data?.success && response?.data?.resultMessage !== '') {
      const userObjectJson = JSON.stringify(loginData);
      if (loginData?.UserType === 2) {
        Cookies.remove('userDataProofreader');
        Cookies.set('userDataProofreader', userObjectJson, {
          expires: 240 / 1440,
          secure: true,
        });
        action?.data?.rememberMe === false &&
          Cookies.remove('emailProofreader') &&
          Cookies.remove('passwordProofreader');
        yield call(forwardTo, DASHBOARD_ROUTE);
      } else {
        toast.error('Only proofreaders are allowed to logged in.');
      }
      yield put(userLoginSuccess(response));
    } else {
      if (response?.data?.errorMessage !== '' && !response.data?.success) {
        toast.error(response?.data?.errorMessage);
      }
      yield put({
        type: types.VALIDATE_LOGIN_USER_FAILED,
        data: loginData,
      });
    }
  } catch (error) {
    yield put(userLoginFailure(error));
  }
}

export function* watchLogin() {
  yield takeLatest(types.VALIDATE_LOGIN_USER_REQUEST, handleLoginAPI);
}
